<template>
  <div>
    <card-tabs
      v-model="activeColumnTab"
      class="overview-order d-flex"
      :stretch="true"

      :tabs="columnTabs"
      :no-margin="true"
    />
    <card>
      <div class="right-column">
        <ShippingAddress
          v-if="activeColumnTab === 'shipping-address'"

          :loading="loading"
          :order-data="selectedOrder"
          @reload="$emit('reload')"
        />
        <BillingAddress
          v-else

          :loading="loading"
          :order-data="selectedOrder"
          @reload="$emit('reload')"
        />
      </div>

      <div class="TAILWIND">
        <div class="p-4" style="border-top: 1px solid #dee2e6">
          <h4 class="font-bold m-0">Notes</h4>
          <FormTextarea
            :value="value"
            @input="newVal => $emit('input', newVal)"

            placeholder="Notes..."
            class="mt-3"
            rows="17"

            ref="textarea"
          />
          <button class="btn btn-success" style="margin-top: 8px !important;" @click="$emit('save')">
            Save notes!
          </button>
        </div>
      </div>
    </card>
  </div>
</template>

<script>

import CardTabs from "@/layout/CardTabs"
import ShippingAddress from "@/components/OrderOverview/ShippingAddress"
import BillingAddress from "@/components/OrderOverview/BillingAddress"
import FormTextarea from "/src/components/Inputs/FormTextarea.vue"

export default {
  props: {
    loading: Boolean,
    selectedOrder: Object,
    value: String,
  },
  components: {
    BillingAddress,
    CardTabs,
    ShippingAddress,
    FormTextarea,
  },
  data() {
    return {
      activeColumnTab: 'shipping-address',
    }
  },
  computed: {
    columnTabs() {
      return [
        {
          name: "Afleveradres",
          id: 'shipping-address',
        },
        {
          name: "Factuuradres",
          id: 'billing-address',
        },
      ]
    },
  }
}

</script>
